<router-outlet></router-outlet>

<bb-session-timeout-modal></bb-session-timeout-modal>
<!-- <bn-transaction-signing-widget-extended></bn-transaction-signing-widget-extended> -->
